const createAlertBlock = (type, message, duration = 5000) => {
  const div = document.createElement("div");
  div.id = `alert-${document.totalAlertAmount}`;
  div.className = `alert-block animate__animated alert-${type} text-12 pt-1`;
  div.innerText = message;
  EnterAnimation(div);

  // Create progress bar container
  const loadingBarContainer = document.createElement("div");
  loadingBarContainer.classList.add("loading-bar-container");

  // Create progress bar
  const loadingBar = document.createElement("div");
  loadingBar.classList.add("loading-bar");
  if (type === "danger") {
    loadingBar.classList.add("danger");
    loadingBarContainer.classList.add("danger");
  }
  loadingBar.style.width = "100%"; // Start full
  loadingBarContainer.appendChild(loadingBar);

  div.appendChild(loadingBarContainer);

  let timeElapsed = 0;
  const interval = setInterval(() => {
    timeElapsed += 100;
    const percentage = -15 + (timeElapsed / duration) * 115;
    loadingBar.style.width = `${Math.abs(percentage)}%`;

    if (timeElapsed >= duration) {
      clearInterval(interval);
      ExitAnimation(div);
      timeout(400).then(() => {
        div.remove();
      });
      // Remove alert when time is up
    }
  }, 100);

  return div;
};

document.totalAlertAmount = 0;

export const generateAlert = (type, message) => {
  const wrapper = document.getElementById("custom-alert-wrapper");
  wrapper.appendChild(createAlertBlock(type, message));

  document.totalAlertAmount++;
};
const EnterAnimation = (element) => {
  element.classList.remove("animate__backOutLeft");
  element.classList.add("animate__backInRight");
};

const ExitAnimation = (element) => {
  element.classList.remove("animate__backInRight");
  element.classList.add("animate__backOutRight");
};

const timeout = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
